import type { Incident } from '@pa/api/clinic'
import { Pager } from '@pa/ui'
import { incidentMeta } from '../model/format'
import { componentName, HISTORY_DAYS } from '../model/labels'

/** C-12's 20 incidents per page (API.md §1.5). */
export const INCIDENTS_PAGE_SIZE = 20

/**
 * C-12 / S-04 Health / S-07 incident history (UserFlows C-12, S-07): ongoing first, then newest first; title,
 * component, "Wed, Oct 7 · 4:23 PM – 4:32 PM · down 9 min" ("ongoing" while open), the resolution; 20 per page.
 * S-07 adds the clinic.
 */
export function IncidentList({
  items,
  page,
  pageSize = INCIDENTS_PAGE_SIZE,
  total,
  timeZone,
  showClinic = false,
  onPage,
}: {
  items: readonly Incident[]
  page: number
  pageSize?: number
  total: number
  timeZone: string
  showClinic?: boolean
  onPage: (page: number) => void
}) {
  if (total === 0) return <div className="empty">No incidents in the last {HISTORY_DAYS} days</div>
  return (
    <>
      <ul className="incidents">
        {items.map((x) => (
          <li key={x.id}>
            <span className={`inc-dot lv-${x.level}`} aria-hidden />
            <div className="grow">
              <div className="inc-title">
                <b>{x.title}</b>
                <span className="inc-comp">{componentName(x.component)}</span>
                {showClinic && x.clinic && <span className="inc-comp inc-clinic">{x.clinic.name}</span>}
              </div>
              <div className="inc-meta">{incidentMeta(x, timeZone)}</div>
              {x.resolution && <div className="inc-res">{x.resolution}</div>}
            </div>
          </li>
        ))}
      </ul>
      <Pager page={page} pageSize={pageSize} total={total} noun="incidents · newest first" onPage={onPage} />
    </>
  )
}
